<template>
  <div id="app">
    <Nav />
    <router-view id="main" />
    <img
      id="copyright-show"
      src="./assets/images/copyright.png"
      @click.stop="copyrightFn"
    />
    <div id="copyright" ref="copyright" @click.stop="closeCopyright">
      <p class="pra">
        Copyright ©2014-2023 <a href="https://91act.com/">91Act.com</a> All
        Rights Reserved 成都格斗科技有限公司 © ARC SYSTEM WORKS/© 91ACT
      </p>
      <p class="pra">
        川B2-20180234 川网文[2017] 9950-404号
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002001031"
          >川公网安备 51019002001031号</a
        >
        <a href="https://beian.miit.gov.cn/">蜀ICP备16027783号</a>
      </p>
      <p class="pra">
        健康游戏公告:抵制不良游戏 拒绝盗版游戏 注意自我保护 防受骗上当
        沉迷游戏伤身 合理安排时间 享受健康生活
      </p>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import DevicePixelRatio from "@/utils/devicePixelRatio";
import ZoomRatio from "@/utils/zoom";

export default {
  components: {
    Nav,
  },
  data() {
    return {
      copyrightBol: false,
    };
  },
  created() {
    new DevicePixelRatio().init();
    new ZoomRatio().init();
  },
  mounted() {
    if (this.isMobile()) {
      location.href = "https://bbee-mobile.91act.com ";
    }
  },
  watch: {
    $route() {
      this.closeCopyright();
    },
  },
  methods: {
    closeCopyright() {
      this.copyrightBol = true;
      this.copyrightFn();
    },
    copyrightFn() {
      this.copyrightBol = !this.copyrightBol;
      if (this.copyrightBol) {
        this.$refs.copyright.style.bottom = "0px";
      } else {
        this.$refs.copyright.style.bottom =
          "-" + this.$refs.copyright.offsetHeight + "px";
      }
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style lang="scss">
//初始化样式，避开浏览器自带样式
body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
fieldset,
legend,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}
body,
button,
input,
select,
textarea {
  font: 12px/1.5tahoma, arial, \5b8b\4f53;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
}
address,
cite,
dfn,
em,
var {
  font-style: normal;
}
code,
kbd,
pre,
samp {
  font-family: sans-serif;
}
small {
  font-size: 12px;
}
ul,
ol {
  list-style: none;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
sup {
  vertical-align: text-top;
}
sub {
  vertical-align: text-bottom;
}
legend {
  color: #000;
}
fieldset,
img {
  border: 0;
}
button,
input,
select,
textarea {
  font-size: 100%;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
#app {
  width: 1920px;
  height: 983px;
  position: fixed;
  left: 0;
  right: 0;
  //全局字体设置
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
//主要内容样式
#main {
  width: 100%;
  height: calc(100% - 97px);
  position: absolute;
  left: 0;
  top: 97px;
}
#copyright {
  width: 1920px;
  padding: 20px 0;
  position: absolute;
  bottom: -140px;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.8);
  transition: all 0.5s ease;
  color: #fff;
}
#copyright a{
  color: blue;
}
#copyright-show {
  display: block;
  width: 105px;
  height: 16px;
  position: absolute;
  left: 1785px;
  bottom: 60px;
  z-index: 999999;
  cursor: pointer;
}
.pra {
  width: 1500px;
  text-align: center;
  margin: 10px 210px;
}
</style>
